<ac-icon size="small" [name]="icon.name" [color]="icon.color" />
